<script lang="ts">
    export let order: "asc" | "desc";
</script>

{#if order === "asc"}
↑
{:else if order === "desc"}
↓
{/if}